export const VIP_DECO_CODE_TO_SVG_SRC: Record<string, string> = {
  2412201: '/img/vipDeco/ico_vip_deco_2412201.svg',
  2412202: '/img/vipDeco/ico_vip_deco_2412202.svg',
  2412203: '/img/vipDeco/ico_vip_deco_2412203.svg',
  2412104: '/img/vipDeco/ico_vip_deco_2412104.svg',
  2412105: '/img/vipDeco/ico_vip_deco_2412105.svg',
  2412107: '/img/vipDeco/ico_vip_deco_2412107.svg',

  2512104: '/img/vipDeco/ico_vip_deco_2512104.svg',
  2512105: '/img/vipDeco/ico_vip_deco_2512105.svg',
  2512107: '/img/vipDeco/ico_vip_deco_2512107.svg',
  2512201: '/img/vipDeco/ico_vip_deco_2512201.svg',
  2512202: '/img/vipDeco/ico_vip_deco_2512202.svg',
  2512203: '/img/vipDeco/ico_vip_deco_2512203.svg',
};
